export const styles = {
  container: {
    gap: '12px',
  },
  list: {
    //padding: '12px',
    gap: '8px',
  },
  notification: {
    backgroundColor: '#EEEEEE',
    flexDirection: 'row',
    borderRadius: '4px',
    padding: '12px',
    gap: '8px',
  },
  icon: {},
  title: {
    color: '#787878',
    fontSize: '12px',
    fontWeight: '400',
  },
  message: {
    //width: '200px',
    fontSize: '14px',
    fontWeight: '400',
  },
  buttons: {
    margin: '-8px -8px 0px 0px',
    gap: '-12px',
  },
  iconButton: {
    width: '38px',
    height: '38px',
  },
  clearButton: {
    marginLeft: 'auto',
    padding: '0px 8px',
    fontSize: '14px',
    fontWeight: '500',
  },
  noNotifications: {
    backgroundColor: '#EEEEEE',
    borderRadius: '4px',
    padding: '12px',
    textAlign: 'center',
    color: '#787878',
    fontSize: '14px',
  },
}
